export default __webpack_public_path__ + "images/Smoothies.42ccd1.jpg";